import { render, staticRenderFns } from "./CommentTable.vue?vue&type=template&id=03c5b1ce&"
import script from "./CommentTable.vue?vue&type=script&lang=js&"
export * from "./CommentTable.vue?vue&type=script&lang=js&"
import style0 from "./CommentTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports